import { useEffect, useState } from "react";
import Nav from "@/components/Nav";
import Cursor from "@/components/Cursor";
import IntroOverlay from "@/components/IntroOverlay";
import Hero from "@/components/Hero";
import Chapters from "@/components/Chapters";
import Marquee from "@/components/Marquee";
import Archive from "@/components/Archive";
import Footer from "@/components/Footer";

export default function HomePage() {
  const [navLogoVisible, setNavLogoVisible] = useState(false);

  useEffect(() => {
    const el = document.querySelector('[data-testid="hero-logo"]');
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => setNavLogoVisible(!entry.isIntersecting),
      { threshold: 0 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div data-testid="fmf-home" className="relative">
      <Cursor />
      <Nav showLogo={navLogoVisible} />
      <IntroOverlay />
      <main>
        <Hero />
        <Chapters />
        <Marquee />
        <Archive />
      </main>
      <Footer />
    </div>
  );
}
